import * as React from "react";
import "./OfferTicket.scss";
import {Business, LocationOffer, UserCard} from "../../../types/Types";
import {convertTimestampToDate, getUsages} from "../../../utils/Utils";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faClock, faStar, faTicket} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router";

interface Props {
  offer: LocationOffer,
  business: Business | undefined,
  pointsCard: UserCard | undefined,
  showReceipt: boolean,
}

function OfferTicket(props: Props) {
  const navigate = useNavigate();

  const limitPerCard = (limitPerCard: number | undefined) => {
    let usages = getUsages(props.pointsCard, props.offer);
    if(props.pointsCard && usages && limitPerCard !== undefined && limitPerCard > 0) {
      return `x ${limitPerCard - usages}`
    } else if(limitPerCard !== undefined && limitPerCard > 0) {
      return `x ${limitPerCard}`
    } else {
      return "Unlimited"
    }
  };

  return (
      <div className={`${props.showReceipt ? 'ticket-receipt' : 'ticket'}`} onClick={() => navigate(`/offer/${props.offer.id}${props.pointsCard ? `-${props.pointsCard.id}` : ``}`)}>
        <div className={"offer-description d-inline-block font-1-8 font-receipt font-weight-600"} style={{marginTop: "-4px", marginBottom: "-8px"}}>{props.offer.description.toUpperCase()}</div>
        <div className={"float-right right-align"} style={{marginTop: "5px"}}>
          <div className={`d-inline-block tag font-1 black`}>
            <div className={"d-inline-block"}>
              {props.offer.pointsCost}<FontAwesomeIcon className={"ms-1"} icon={faStar}/>
            </div>
          </div>
          <div className={"font-dark-grey"}>
            <span className={"font-md font-weight-600 font-black"}>{limitPerCard(props.offer.limitPerCard)}</span>
            <FontAwesomeIcon className={"ms-1 font-1 font-black"} icon={faTicket}/>
          </div>
        </div>
      </div>
  )
}

export default OfferTicket;